export default "__VITE_ASSET__Ct4W9uOZ__"